/**
 * A flag do catálogo de compras, pelo NOME — o mesmo que o backend grava em
 * `feature_flag` e que `wireComprasCatalogo` consulta.
 *
 * Nasce AUSENTE da tabela, e `flags.IsEnabled` é fail-safe (chave ausente =
 * desligada): ausência é o desligado mais forte que existe, porque não há
 * linha para alguém marcar `ativo=true` por engano.
 */
export const FLAG_COMPRAS_CATALOGO = 'compras.catalogo.habilitado'
